import { $AjaxJson } from '../lf'
import { $Urlpath, $UrlApipath } from '../config/config'
export const PublicDataRequest = {

    GetPublicDataByType(func, Type, OldID) {
        $AjaxJson($UrlApipath + "PublicData/GetPublicDataByType", { Type: Type, OldID: OldID }, function (d) {
            func(d)
        })

    },

    AddPublicData(func, obj) {
        $AjaxJson($UrlApipath + "PublicData/AddPublicData", obj, function (d) {
            func(d)
        })
    },
    UpdatePublicData(func, obj) {
        $AjaxJson($UrlApipath + "PublicData/UpdatePublicData", obj, function (d) {
            func(d)
        })
    },
    SearchPublicData(func, obj) {
        $AjaxJson($UrlApipath + "PublicData/SearchPublicData", obj, function (d) {
            func(d)
        })
    },
    SearchPublicDataList(func, obj) {
        $AjaxJson($UrlApipath + "PublicData/SearchPublicData", obj, function (d) {
            func(d)
        })
    },
    DeletePublicData(func, ID) {
        $AjaxJson($UrlApipath + "PublicData/DeletePublicData", { ID: ID }, function (d) {
            func(d)
        })
    },

    SetPublicDataCreateUserID(func, ID, CreateUserID) {
        $AjaxJson($UrlApipath + "PublicData/SearchPublicData", { ID: ID, CreateUserID: CreateUserID }, function (d) {
            func(d)
        })
    },
    SetPublicDataModifyUserID(func, ID, ModifyUserID) {
        $AjaxJson($UrlApipath + "PublicData/SearchPublicData", { ID: ID, ModifyUserID: ModifyUserID }, function (d) {
            func(d)
        })
    },
    SetPublicDataPublicType(func, ID, PublicType) {
        $AjaxJson($UrlApipath + "PublicData/SearchPublicData", { ID: ID, PublicType: PublicType }, function (d) {
            func(d)
        })
    },
    SetPublicDataStatus(func, ID, Status) {
        $AjaxJson($UrlApipath + "PublicData/SearchPublicData", { ID: ID, Status: Status }, function (d) {
            func(d)
        })
    },
}



// WEBPACK FOOTER //
// ./src/request/PublicData.js